export type HighchartsPoint = { name?: string; y: number; x?: number };

export interface HighchartsChartOptions {
  chart?: { type?: string; backgroundColor?: string };
  title?: { text?: string };
  xAxis?: { categories?: string[]; type?: string };
  yAxis?: { title?: { text?: string } };
  series?: Array<{
    name?: string;
    data?: Array<number | HighchartsPoint>;
    color?: string;
  }>;
  legend?: { enabled?: boolean };
  credits?: { enabled?: boolean };
  plotOptions?: Record<string, unknown>;
  tooltip?: Record<string, unknown>;
}

interface HighchartsStatic {
  chart: (
    renderTo: HTMLElement,
    options: HighchartsChartOptions,
  ) => { destroy: () => void };
}

declare global {
  interface Window {
    Highcharts?: HighchartsStatic;
  }
}

let loadPromise: Promise<HighchartsStatic> | null = null;

export function loadHighcharts(): Promise<HighchartsStatic> {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Highcharts requires a browser"));
  }
  if (window.Highcharts) return Promise.resolve(window.Highcharts);

  if (!loadPromise) {
    loadPromise = new Promise<HighchartsStatic>((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://code.highcharts.com/highcharts.js";
      script.async = true;
      script.onload = () => {
        if (window.Highcharts) resolve(window.Highcharts);
        else reject(new Error("Highcharts failed to load"));
      };
      script.onerror = () => reject(new Error("Highcharts script error"));
      document.head.appendChild(script);
    }).catch((err) => {
      loadPromise = null;
      return Promise.reject(err);
    });
  }

  return loadPromise;
}
